import { css } from '@emotion/core';
import { findLastIndex } from 'lodash';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const containerSizesShop = {
  background: '#fff',
  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '0px',
  },
};

export const FeatureBulletLink = {
  '.bulletimg': {
    margin: '0px 111px',
  },
};

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',

  '.bulletimg': {},

  '.imgsec': {
    '.img1': {
      width: '100%',
    },
    '.img2': {
      position: 'absolute',
      top: '272px',
      left: '281px',
      width: '100%',
    },
    img: {},
  },

  '.contentsec ': {
    img: {},
    [MediaQueries.lg]: {
      maxWidth: '300px',
      marginLeft: '0px',
    },
    [MediaQueries.md]: {
      maxWidth: '300px',
      marginLeft: '0px',
    },
    h2: {
      fontSize: '58px',
      fontWeight: '500',
      lineHeight: '56px',
      letterSpacing: '-1px',
      maxWidth: '350px',
      marginBottom: '24px',

      [MediaQueries.sm]: {
        fontSize: '40px',
        fontWeight: '500',
        lineHeight: '48px',
        letterSpacing: '-0.3px',
        textAlign: 'center',
        marginBottom: '24px',
      },
    },

    p: {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '32px',
      letterSpacing: '0px',
      textAlign: 'center',
    },

    '.listsec': {
      maxWidth: '404px',
      ul: {
        li: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: 1.5,
          alignItems: 'flex-start',
          display: 'flex',
          marginBottom: '24px',
          paddingRight: '10px',
          verticalAlign: 'middle',

          '.icon_img': {
            display: 'inline-block',
            height: '18px',
            margin: '3px 13px 0 0',
            minWidth: '18px',
            verticalAlign: 'middle',
            width: '18px',

            img: {
              width: '16px',
              height: '16px',
            },
          },
        },
      },
    },

    '.cta': {
      a: {
        color: colorsPalette.red,

        textDecoration: 'none',
        fontWeight: '400',

        span: {
          borderBottom: `1px solid ${colorsPalette.red}`,
        },
      },
    },
  },
});
